import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.tsx";
// Order matters: tokens define the custom properties, base consumes them, and `@kinetiq/ui/ui.css` reads
// `--line` and `--muted` from our `:root` — so it must come last, after both are defined.
import "./ui/tokens.css";
import "./ui/base.css";
import "@kinetiq/ui/ui.css";
import { assertPresent } from "./lib/assert.ts";

const root = assertPresent(document.getElementById("root"), "index.html must contain #root");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
